import React, { useMemo } from 'react';
import { formatCurrency } from 'utils';
import { Stack, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { MARKUP_TYPE } from '@trnsact/business-criteria/dist/src/models/rule-event/aftermarket/markup-type';
import { ProductConfig } from '../../../../types';

interface Props {
  rowIndex: number;
}

export const RetailPriceCell = ({ rowIndex }: Props) => {
  const { control } = useFormContext<ListingForm<ProductConfig>>();
  const row = useWatch({ control, name: `bodyFields.${rowIndex}` });

  const price = useMemo(() => {
    if (row.markup.type === MARKUP_TYPE.FIXED) {
      return row.cost.value + row.markup.value;
    }

    return row.cost.value * (1 + row.markup.value / 100);
  }, [row]);

  return (
    <Stack direction="row" alignItems="flex-start" height="100%">
      <RenderWithCondition
        condition={row.cost.isUseRateFactor}
        fallBack={<Typography>{formatCurrency(price, true)}</Typography>}
      >
        <Typography>N/A</Typography>
      </RenderWithCondition>
    </Stack>
  );
};
